import { SVGProps } from "react";

/**
 * Illustration for the "Outlet Number Exceeded!" dialog, composed exactly as in
 * the design: a 168 x 92.439 box holding two vectors - the pale shelf group,
 * bottom-aligned at 20.7114, and the second group centred on the design's
 * bounding box and rotated -173.74deg.
 */
const OutletsLimitExceeded = ({
  width = 168,
  height = 92.439,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 168 92.439"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(23.39 6.69) rotate(-173.74 62.8505 27.55645)">
      <g id="Group 289914">
        <g id="Group 289860">
          <path
            id="Vector 51"
            d="M108.381 41.8059L108.381 45.1517"
            stroke="#F16613"
            strokeWidth="1.04724"
            strokeLinecap="round"
          />
          <path
            id="Vector 52"
            d="M110.11 43.4788L106.652 43.4788"
            stroke="#F16613"
            strokeWidth="1.04724"
            strokeLinecap="round"
          />
        </g>
        <path
          id="Ellipse 3"
          d="M80.3276 53.231C80.7822 53.231 81.1313 53.5852 81.1313 53.9976C81.1313 54.41 80.7823 54.7642 80.3276 54.7642C79.873 54.7641 79.5238 54.4099 79.5238 53.9976C79.5238 53.5853 79.873 53.2312 80.3276 53.231Z"
          stroke="#C9D0D6"
          strokeWidth="0.698159"
        />
        <circle
          id="Ellipse 4"
          cx="29.1356"
          cy="38.2515"
          r="3.11379"
          stroke="#C9D0D6"
          strokeWidth="0.698159"
        />
        <path
          id="Ellipse 5"
          d="M53.8531 47.9835C54.8532 47.9838 55.6344 48.7642 55.6344 49.6905C55.6344 50.6169 54.8532 51.3973 53.8531 51.3976C52.8528 51.3976 52.0709 50.6171 52.0709 49.6905C52.0709 48.764 52.8528 47.9835 53.8531 47.9835Z"
          stroke="#E67068"
          strokeWidth="1.04724"
        />
        <path
          id="Ellipse 7"
          d="M2.30566 28.9085C3.30575 28.9087 4.08691 29.6891 4.08691 30.6155C4.08691 31.5419 3.30576 32.3223 2.30566 32.3226C1.30534 32.3226 0.523438 31.5421 0.523438 30.6155C0.523445 29.689 1.30534 28.9085 2.30566 28.9085Z"
          stroke="#E67068"
          strokeWidth="1.04724"
        />
        <path
          id="Ellipse 6"
          d="M122.819 0.698242C124.047 0.698427 125.002 1.65546 125.002 2.78809C125.002 3.92072 124.047 4.87774 122.819 4.87793C121.592 4.87793 120.636 3.92083 120.636 2.78809C120.636 1.65535 121.592 0.698242 122.819 0.698242Z"
          stroke="#E7EBEE"
          strokeWidth="1.39632"
        />
      </g>
    </g>
    <g transform="translate(0 20.7114)">
      <g id="Group 289931">
        <path
          id="Vector"
          d="M168 52.6324C168 59.1715 153.542 64.9403 131.496 68.381C120.191 70.1442 106.892 71.2997 92.5194 71.6249C89.7144 71.6934 86.8784 71.7276 84.0039 71.7276C67.9851 71.7276 53.0095 70.7091 40.2749 68.9374C16.1192 65.5822 0 59.5396 0 52.6324C0 45.7253 16.1192 39.6826 40.2749 36.3361C53.0095 34.5643 67.9851 33.5458 84.0039 33.5458C86.8784 33.5458 89.7144 33.58 92.5194 33.64C92.9676 33.6485 93.4235 33.6656 93.8794 33.6742C107.526 34.0422 120.168 35.1463 131.009 36.8154C153.326 40.239 168 46.042 168 52.6324Z"
          fill="#F6F7F7"
        />
        <path
          id="Vector_2"
          d="M153.156 51.3468C153.156 54.3335 147.522 57.0826 138.121 59.2292C127.71 61.6135 112.683 63.268 95.569 63.7177C95.4841 63.7177 95.4078 63.7262 95.3229 63.7262C92.2854 63.8026 89.1799 63.845 86.0235 63.845C67.2975 63.845 50.3617 62.4196 38.186 60.1202C26.2563 57.8632 18.8914 54.7662 18.8914 51.3468C18.8914 47.9274 26.2563 44.8474 38.1775 42.582C50.3532 40.2826 67.289 38.8571 86.0235 38.8571C89.2902 38.8571 92.506 38.8996 95.6454 38.9844C95.7132 38.9844 95.7811 38.9844 95.849 38.9929C112.836 39.4511 127.752 41.0971 138.104 43.4729C147.513 45.6196 153.156 48.3602 153.156 51.3468Z"
          fill="#C9D0D6"
        />
        <path
          id="Vector_3"
          d="M95.5689 62.8688C95.5774 55.9028 95.501 40.6555 95.5519 40.1379C95.5604 39.9852 95.5689 39.824 95.5774 39.6712C95.6028 39.1621 95.6283 38.6531 95.6453 38.1355C96.0101 27.6567 94.7204 15.7694 87.1434 8.72699C70.4028 -10.1773 37.3034 3.77184 38.1859 30.0834C38.1689 33.0276 38.1689 37.2276 38.1859 41.7331C38.1859 47.7743 38.2028 54.3755 38.1859 59.2712C50.3616 61.5706 67.2974 62.9961 86.0234 62.9961C89.1798 62.9961 92.2853 62.9537 95.3228 62.8773"
          fill="#F6F7F7"
        />
        <path
          id="Vector_4"
          d="M97.2658 62.869C114.38 62.4193 129.406 60.7648 139.817 58.3805V43.1163C139.817 42.9551 139.817 42.7854 139.8 42.6242C139.783 41.0714 139.605 39.5781 139.283 38.1272C138.383 33.9017 136.356 30.1345 133.547 27.1902C129.678 23.109 124.324 20.589 118.419 20.589C109.374 20.589 101.636 26.4945 98.5131 34.852C98.1143 35.9127 97.7834 37.0157 97.5458 38.1442C97.4355 38.6448 97.3422 39.1539 97.2743 39.6714C97.2489 39.8242 97.2234 39.9854 97.2064 40.1466C97.0792 41.1223 97.0198 42.1066 97.0198 43.1163V62.8775"
          fill="#F6F7F7"
        />
        <path
          id="Vector_5"
          d="M55.0029 22.9226C56.5587 22.9226 57.8199 21.6614 57.8199 20.1057C57.8199 18.5499 56.5587 17.2887 55.0029 17.2887C53.4472 17.2887 52.186 18.5499 52.186 20.1057C52.186 21.6614 53.4472 22.9226 55.0029 22.9226Z"
          fill="#9EA7B0"
        />
        <path
          id="Vector_6"
          d="M80.6526 22.9226C82.2084 22.9226 83.4696 21.6614 83.4696 20.1057C83.4696 18.5499 82.2084 17.2887 80.6526 17.2887C79.0968 17.2887 77.8356 18.5499 77.8356 20.1057C77.8356 21.6614 79.0968 22.9226 80.6526 22.9226Z"
          fill="#9EA7B0"
        />
        <path
          id="Vector_7"
          d="M126.887 41.3772C128.091 41.3772 129.067 40.4009 129.067 39.1966C129.067 37.9923 128.091 37.016 126.887 37.016C125.682 37.016 124.706 37.9923 124.706 39.1966C124.706 40.4009 125.682 41.3772 126.887 41.3772Z"
          fill="#9EA7B0"
        />
        <path
          id="Vector_8"
          d="M107.931 41.3772C109.136 41.3772 110.112 40.4009 110.112 39.1966C110.112 37.9923 109.136 37.016 107.931 37.016C106.727 37.016 105.751 37.9923 105.751 39.1966C105.751 40.4009 106.727 41.3772 107.931 41.3772Z"
          fill="#9EA7B0"
        />
        <path
          id="Vector_9"
          d="M63.0721 28.472C63.6406 26.9278 65.1254 25.8332 66.8648 25.8332C68.6042 25.8332 70.0891 26.9278 70.6575 28.472"
          stroke="#9EA7B0"
          strokeWidth="1.27273"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          id="Vector_10"
          d="M114.057 45.195C114.49 44.0156 115.627 43.1841 116.951 43.1841C118.274 43.1841 119.411 44.0241 119.844 45.195"
          stroke="#9EA7B0"
          strokeWidth="1.27273"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);

export default OutletsLimitExceeded;
